import type { FC, MouseEvent } from 'react';
import {
  Box,
  Actions,
  Inline,
  Button,
  useResponsiveValue,
  IconThumb,
} from 'braid-design-system';
import { BUCKETS } from '../../../stores/JobApplicationStore/types';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import { Display } from 'src/libs/Display';

interface Props {
  idPrefix: string;
  fullName: string;
  onStatusChange: (bucket: BUCKETS) => void;
}

const InboxStatusButtons: FC<Props> = (props) => {
  const { t } = useTranslations(translations);
  const { idPrefix, fullName } = props;
  const createStatusChange = (bucket: BUCKETS) => {
    const { onStatusChange } = props;
    return (e: MouseEvent<HTMLElement> | undefined) => {
      if (e) {
        e.stopPropagation();
      }
      onStatusChange(bucket);
    };
  };
  const responsiveValue = useResponsiveValue();

  return (
    <Box
      data-cy="inbox-status-buttons"
      data-testid="inbox-status-buttons"
      data-intercom-target="inbox-status-buttons"
    >
      <Actions>
        <Inline space="small" align="center">
          <Button
            size="small"
            variant={
              responsiveValue({ mobile: 'soft', tablet: 'ghost' }) ?? 'ghost'
            }
            tone="neutral"
            aria-label={t('Move fullName to Not Suitable', { fullName })}
            aria-describedby={`${idPrefix}-button-not-suitable`}
            onClick={createStatusChange(BUCKETS.NOT_SUITABLE)}
            data={{ testid: 'mark-not-suitable' }}
          >
            <Inline
              space={
                // FIXME: We can set this to 'xsmall' when we switch to Braid v33
                responsiveValue({ mobile: 'none', tablet: 'xsmall' }) ??
                'xsmall'
              }
              align="center"
            >
              <IconThumb direction="down" />
              <Display tablet desktop>
                {t('Not Suitable')}
              </Display>
            </Inline>
          </Button>
          <Button
            size="small"
            variant={
              responsiveValue({ mobile: 'soft', tablet: 'ghost' }) ?? 'ghost'
            }
            tone="neutral"
            aria-label={t('Shortlist fullName', { fullName })}
            onClick={createStatusChange(BUCKETS.SHORTLIST)}
            data={{ testid: 'mark-suitable' }}
          >
            <Inline
              space={
                // FIXME: We can set this to 'xsmall' when we switch to Braid v33
                responsiveValue({ mobile: 'none', tablet: 'xsmall' }) ??
                'xsmall'
              }
              align="center"
            >
              <IconThumb />
              <Display tablet desktop>
                {t('Shortlist')}
              </Display>
            </Inline>
          </Button>
        </Inline>
      </Actions>
    </Box>
  );
};

export default InboxStatusButtons;
